import React, { Component } from 'react'
import moment from 'moment'
import { Button, message, Modal, Descriptions } from 'antd'
import icon_download from '../img/icon_download.png'


export default class UploadListItem extends Component {
    constructor(props) {
        super(props)
        this.state = {
            item: this.props.item,
            wsToClientTimerFlag: false,
            isShow:false,
            data:{}
        }
    }

    render() {
        const {item} = this.state
        const { orderCreationTime, orderId, orderStatus, resourceType, proOrderList } = item
        const { expendId, setExpend } = this.props
        return (
            <div className='order-produce-list-item'>
                <div className='order-produce-list-item-unit'>
                    <span className='order-produce-list-item-title'>{orderId}</span>
                    <Button size='small' className='download-order-list-item-button' type="primary" onClick={() => this.setState({isShow:true})}>详情</Button>
                </div>
                <div className='order-produce-list-item-split' />
                <div className='order-produce-list-item-unit'>
                    <div>
                        <span className='order-produce-list-item-text1'>数据来源：{resourceType}</span>
                        <span className='order-produce-list-item-text1'>订单状态：{orderStatus}</span>
                    </div>
                    <span className='order-produce-list-item-text2'>下单时间：{moment(orderCreationTime).format("yyyy-MM-DD HH:mm:ss")}</span>
                </div>
                <Modal title="详情" visible={this.state.isShow} footer={null} width="60%" onCancel={()=>{this.setState({isShow:false})}}>
                    <Descriptions column={2} bordered>
                        <Descriptions.Item label="文件名">{item.fileName}</Descriptions.Item>
                        <Descriptions.Item label="文件大小">{item.fileSize}</Descriptions.Item>
                        <Descriptions.Item label="文件类型">{item.resourceType}</Descriptions.Item>
                        <Descriptions.Item label="订单创建时间">{item.orderCreationTime}</Descriptions.Item>
                        <Descriptions.Item label="订单状态">{item.orderStatus}</Descriptions.Item>
                        <Descriptions.Item label="状态更新时间">{item.statusUpdateTime}</Descriptions.Item>
                    </Descriptions>
                </Modal>
            </div>
        )
    }

    openClient = (data) => {
        //通过这个循环保证修改每个订单的下载状态
        // console.log('openClient',data)
        let flag = true;
        data.map((item) => {
            if (!item.orderDownloadAddr) {
                let flag = false;
            }
        })
        if (!flag) {
            message.error("下载订单内含有没有文件地址的订单，请确认订单完成后重试！");
            return;
        }
        // return;
        let _this = this;
        const linkTmp = document.createElement('a');
        linkTmp.href = 'ydspacebasedbee://';


        linkTmp.onclick = function (e) {
            _this.callapp_openClient({
                data: data,
                callbackTrue: function (dataT) {
                    message.success("准备打开客户端，正在预备下载！");
                    _this.createWSForSimple(data);
                },
                callbackFlase: function () {
                    message.info("检测到本机未安装客户端，请先安装客户端后再下载订单！");
                    console.log("客户端打开失败！");
                }
            });
        }
        linkTmp.click();
    }

    //确认客户端是否被打开的回调函数（感觉有点离谱，但是暂时确实想不到更好的办法，好像百度网盘也是类似的逻辑）
    callapp_openClient({ data, callbackTrue, callbackFlase }) {
        var t = setTimeout(callbackFlase, 1000);
        var inp = document.createElement("input");
        inp.style.position = "absolute";
        inp.style.clip = "rect(0, 0, 0, 0)";
        // 出现下载框的时候往下跳的问题
        inp.style.top = '0'
        inp.style.left = '0'
        // inp.style.display="none";
        function blur() {
            window.clearTimeout(t);
            callbackTrue(data);
        }
        inp.addEventListener("blur", blur); // 监听blur事件
        document.body.appendChild(inp);
        inp.focus(); // 获取焦点
        setTimeout(function () { // 删除无用的标签
            inp.removeEventListener("blur", blur);
            document.body.removeChild(inp);
        }, 1000);
        //有客户端 如果有本地exe应用，就会弹框，input失去焦点，然后执行blur()事件 清空t定时器 - 删除无用的标签定时器
        //无客户端 不会弹框，input也不会失去焦点 触发t定时器- 执行callback - 删除无用的标签定时器
    }

    createWSForSimple = (data) => {
        let _this = this;
        this.webSocketClient = new WebSocket('ws://127.0.0.1:9312');// 新建一个WebSocket通信，连接一个本地服务器
        this.webSocketClient.onopen = function (e) {             //连接建立时触发函数
            console.log('网站ws通讯已创建，目前状态为：' + _this.webSocketClient.readyState);
            clearInterval(_this.wsTimer);
            _this.setState({ wsToClientTimerFlag: true });
            if (_this.webSocketClient.readyState === 1) {
                _this.wsSendMessage(JSON.stringify({ type: 'download', data: data }));       //传送消息
            }
        }
        this.webSocketClient.onmessage = function (evt) {       //客户端接收服务端数据时触发
            console.log("网站接收到了来自客户端的消息：", evt);//向页面追加显示服务端发送给客户端的消息
        }
        this.webSocketClient.onclose = function (evt) {          //连接关闭时触发
            console.log("网站的连接通关已关闭!", evt);
            if (_this.state.wsToClientTimerFlag) {
                let nowTimer = 0;
                let timeCount = 500;
                let maxTimer = 15000;
                _this.wsTimer = setInterval(() => {
                    _this.createWSForSimple(data);
                    nowTimer += timeCount;
                    console.log("网站尝试连接客户端中，重试：", nowTimer / timeCount);
                    if (nowTimer >= maxTimer) {
                        clearInterval(_this.wsTimer);
                        console.log("网站尝试连接客户端重试结束……");
                    }
                }, timeCount);
                _this.setState({ wsToClientTimerFlag: false });
            }
        };

    }

    wsSendMessage = (mes) => {   //向服务端发送消息
        console.log("wsSendMessage", mes);
        this.webSocketClient.send(mes);       //传送消息
    }
}
